import useAuth from '@/hooks/auth';
import { useQuery } from '@tanstack/react-query';
import { GETv1UserProfile } from '@/api/member';

type SaveStocks = {
  data: {
    group: number;
    price_alerts: any[];
    product_id: string;
    product_type: string;
    sort: number;
  }[];
  name: string;
};

type UserSaveStocks = {
  1: SaveStocks;
  2: SaveStocks;
  3: SaveStocks;
  4: SaveStocks;
};

const getUserProfile = async () => {
  try {
    const res = await GETv1UserProfile();

    return res?.items;
  } catch (e) {
    console.error(e);
    return {};
  }
};

// ['TWS:3141:STOCK', 'CC:AVAX:FOREX', 'CC:LUNA:FOREX', ... ]
const select = (data: UserSaveStocks): string[] => {
  return (
    Object.values(data)
      ?.map(({ data }) => data?.map(({ product_id }) => product_id))
      .flat() || []
  );
};

const useGetUserSave = () => {
  const [status] = useAuth();
  const isLogin: boolean = status === 'login';

  // 取得使用者自選列表
  const { data = [] } = useQuery({
    queryKey: ['user-save-list'],
    queryFn: getUserProfile,
    enabled: isLogin,
    refetchOnWindowFocus: false,
    select
  });

  return { data };
};

export default useGetUserSave;
